/**
 * The "Fixed · תוקן" chip of a resubmission (#415 item 3): this question had a mistake on an earlier upload of the same sheet and
 * this upload proves it. The server decides it (`fixedSinceEarlier`); this only shows it. It says "after feedback" because fixed work
 * is help-assisted (principle 11) - it is never read as independent - and carries a date, never a count.
 */

import type { HomeworkFeedbackResponse } from '@davinci/contracts';
import { useFeedbackLabels } from '../../i18n/homework-feedback-labels.js';
import { useHomeworkLabels } from '../../i18n/homework-labels.js';

export type FixedEntry = HomeworkFeedbackResponse['fixedSinceEarlier'][number];

/** The entry for a question label, if the server says it is fixed. */
export function fixedEntry(fixed: HomeworkFeedbackResponse['fixedSinceEarlier'], question: string | null): FixedEntry | undefined {
  return question === null ? undefined : fixed.find((entry) => entry.questionLabel === question);
}

export function FixedMark({ entry }: { readonly entry: FixedEntry }): React.JSX.Element {
  const t = useFeedbackLabels();
  const h = useHomeworkLabels();
  return (
    <p className="feedback-fixed">
      <span className="feedback-chip">{t.fixedChip}</span> <span className="field-hint">{t.fixedAfterFeedback(h.dueDate(entry.earlierUploadedAt))}</span>
    </p>
  );
}
